import { motion } from "framer-motion";

// Generic scroll-triggered reveal wrapper. Use stagger when wrapping multiple items.
export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export const staggerParent = {
  hidden: {},
  show: { transition: { staggerChildren: 0.1 } },
};

export default function Reveal({ children, className = "", delay = 0, as = "div", ...rest }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, ease: "easeOut", delay }}
      className={className}
      {...rest}
    >
      {children}
    </Comp>
  );
}
